// 解决js精度问题
import Decimal from 'decimal.js'

// 加法
export function add(val1, val2) {
  if (isNaN(val1) || isNaN(val2)) {
    return NaN
  }
  return Number(new Decimal(val1).add(new Decimal(val2)).valueOf())
}

/**
 * 减法
 * @param {被减数} val1
 * @param {减数} val2
 * @returns
 */
export function sub(val1, val2) {
  if (isNaN(val1) || isNaN(val2)) {
    return 0
  }
  return Number(new Decimal(val1).sub(new Decimal(val2)).valueOf())
}

// 乘法
export function mul(val1, val2) {
  if (isNaN(val1) || isNaN(val2)) {
    return 0
  }
  return Number(new Decimal(val1).mul(new Decimal(val2)).valueOf())
}

/**
 * 除法
 * @param {被除数} val1
 * @param {除数} val2
 * @returns
 */
export function div(val1, val2) {
  if (isNaN(val2) || isNaN(val2) || val2 * 1 === 0) {
    return NaN
  }
  return Number(new Decimal(val1).div(new Decimal(val2)).valueOf())
}

// todo: 函数柯里化，参数复用，入参支持多参数
